import React, { createRef } from 'react';
import { Layout, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import CFooter from '../../component/Footer';
import CHeader from '../../component/Header';
import Cart from '../../component/Cart/Cart';
import RegisterDomain from '../../component/RegisterDomain';

const { Content, Footer, Header, Sider } = Layout;

const CheckDomain = () => {
  const myElem = createRef();

  const isCartOpen = useSelector(({ cart }) => cart.isCartOpen);

  return (
    <Layout style={{ background: '#EFF0F7', height: '100vh' }}>
      <Header
        className="header"
        style={{
          background: '#FCFCFC',
          boxShadow:
            '0px 2px 4px -2px rgba(24, 39, 75, 0.12), 0px 4px 4px -2px rgba(24, 39, 75, 0.08)',
          zIndex: 2
        }}
      >
        <CHeader />
      </Header>
      <Layout className="site-layout-background" style={{ background: '#EFF0F7' }}>
        <Sider width={0} />
        <Content
          style={{
            background: '#EFF0F7',
            height: 'calc(100vh - 150px)',
            overflowY: 'scroll',
            paddingTop: '44px'
          }}
        >
          <Content style={{}}>
            <Row
              align="start"
              justify="center"
              style={{ height: '700px', marginTop: '120px' }}
              type="flex"
            >
              <Col style={{}}>
                <div style={{ fontSize: '48px', marginBottom: '48px' }}>
                  Search for your new domain
                </div>

                <RegisterDomain />
              </Col>
            </Row>
          </Content>
        </Content>
        <div
          ref={myElem}
          style={{
            display: isCartOpen ? 'block' : 'none',
            height: '100%',
            maxWidth: 360,
            position: 'relative',
            width: 360,
            zIndex: 1
          }}
        />
        <Cart getRef={() => myElem.current} visible={isCartOpen} />
      </Layout>
      <Footer
        style={{
          background: '#FCFCFC',
          borderTop: '1px solid #D6D8E7',
          height: '48px',
          padding: 0,
          textAlign: 'center',
          zIndex: 2
        }}
      >
        <CFooter />
      </Footer>
    </Layout>
  );
};

export default CheckDomain;
